import type { EntityFormsOverride } from '@/entity-config-runtime/entity-forms'
import type { EntityFormConfigOverride } from '@/entity-config-runtime/form-config-overrides'
import type { FormField } from '@/shared/forms/utility/composed'

const teamsFormsOverride: EntityFormsOverride = (generatedConfig) => {
	const responsibleUserGroupField = {
		name: 'responsibleUserGroupId',
		label: 'forms_teams_responsible_user_group',
		type: 'autocompleteUserGroups',
		initialValue: null,
	} as unknown as FormField

	const userGroupField = {
		name: 'userGroupId',
		label: 'forms_teams_user_group',
		type: 'autocompleteUserGroups',
		initialValue: null,
	} as unknown as FormField

	const createFields = generatedConfig?.create?.[0]?.fields
	if (
		createFields &&
		!createFields.some((field) => field.name === 'userGroupId')
	) {
		createFields.push({ ...responsibleUserGroupField }, { ...userGroupField })
	}

	const editFields = generatedConfig?.edit?.[0]?.fields
	if (editFields && !editFields.some((field) => field.name === 'userGroupId')) {
		editFields.push({ ...responsibleUserGroupField }, { ...userGroupField })
	}

	return generatedConfig
}

export const entityFormConfigOverride: EntityFormConfigOverride = {
	entity: 'teams',
	override: teamsFormsOverride,
}
